import axios from './api'


export const searchService = (search = '') => {
  return axios(`/site/search/${search}`)
    .then(res => res.data)
}